import { useEffect, useRef } from 'react';

export function useOutsideClick (handler, listenCapturing = true) {
    const ref = useRef(null);

    useEffect(() => {
        function handleClick (e) {
            if (ref.current && !ref.current.contains(e.target)) {
                handler();
            }
        }

        function handleKeyPress (e) {
            if (e.key === 'Escape') {
                handler();
            }
        }

        document.addEventListener('click', handleClick, listenCapturing);
        document.addEventListener('keydown', handleKeyPress, listenCapturing);
        return () => {
            document.removeEventListener('click', handleClick, listenCapturing);
            document.removeEventListener('keydown', handleKeyPress, listenCapturing);
        };
    }, [handler, listenCapturing]);

    return ref;
}
